module.exports = __webpack_public_path__ + "media/images/plusvibes-pdf-logo-b2e87682debbe22a3363b1670d83262d.png";